import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import clsx from "clsx";
import React from "react";
import { Section } from "../useProducDetalsModal";

const SectionsNavMenu = ({
  menuItems,
  clickedMenuItem,
  moveToSection,
  containerClassName,
}: {
  menuItems: Section[];
  clickedMenuItem: string | undefined;
  moveToSection: (item: Section) => void;
  containerClassName?: string;
}) => {
  const [scrollSide, setScrollSide] = React.useState<"right" | "left" | null>(
    null
  );
  const menuRef = React.useRef<HTMLUListElement>(null);

  const scrollToRight = () => {
    menuRef?.current?.scrollTo({
      behavior: "smooth",
      left: menuRef.current.scrollWidth - menuRef.current.clientWidth,
    });
    setScrollSide("right");
  };

  const scrollToLeft = () => {
    menuRef?.current?.scrollTo({
      behavior: "smooth",
      left: 0,
    });
    setScrollSide("left");
  };

  React.useEffect(() => {
    if (menuRef.current) {
      const hasOverflow =
        menuRef.current?.scrollWidth > menuRef.current?.clientWidth;
      hasOverflow &&
        setScrollSide(menuRef.current.scrollLeft === 0 ? "left" : "right");
    }

    return () => setScrollSide(null);
  }, [menuRef.current?.scrollWidth]);

  return (
    <div
      className={clsx(
        "-mt-[1px] bg-white sticky top-0 z-3",
        containerClassName
      )}
    >
      {scrollSide === "right" && (
        <div
          className={clsx(
            "absolute left-0 top-0 cursor-pointer bg-white p-2 h-[98%] flex items-center"
          )}
        >
          <IconChevronLeft
            className={clsx("text-gray-700 hover:text-gray-500 transition")}
            onClick={scrollToLeft}
          />
        </div>
      )}
      <nav
        className={clsx(
          "max-w-[100%] whitespace-nowrap flex border-b border-gray-300",
          "overflow-x-auto scrollbar-hide h-[52px]"
        )}
        ref={menuRef}
      >
        {menuItems
          .filter((item) => !item.hidden)
          .map((item, index) => (
            <a
              href={`#${item.id}`}
              key={index}
              className={clsx(
                "px-4 hover:bg-indigo-50 hover:text-indigo-700 cursor-pointer transition flex items-center",
                {
                  "bg-indigo-50 text-indigo-700 border-b-2 border-indigo-500":
                    item.id === clickedMenuItem,
                }
              )}
              onClick={() => moveToSection(item)}
            >
              {item.name}
            </a>
          ))}
      </nav>
      {scrollSide === "left" && (
        <div
          className={clsx(
            "absolute right-0 top-0 cursor-pointer bg-white p-2 h-[98%] flex items-center"
          )}
        >
          <IconChevronRight
            className={clsx("text-gray-700 hover:text-gray-500 transition")}
            onClick={scrollToRight}
          />
        </div>
      )}
    </div>
  );
};

export default SectionsNavMenu;
